import { useCallback, useState } from 'react';
import { useResizeObserver } from './useResizeObserver';
function deriveElementDimensions(target) {
    const { width, height } = target.getBoundingClientRect();
    return { width, height };
}
export function useElementDimensions(ref, initialValues) {
    const [dimensions, setDimensions] = useState(() => {
        if (initialValues)
            return initialValues;
        if (ref.current)
            return deriveElementDimensions(ref.current);
        return { width: 0, height: 0 };
    });
    const handleResize = useCallback((entries) => {
        if (!entries[0])
            return;
        const rect = deriveElementDimensions(entries[0].target);
        setDimensions({ width: rect.width, height: rect.height });
    }, [setDimensions]);
    useResizeObserver(ref, handleResize);
    return dimensions;
}
//# sourceMappingURL=useElementDimensions.js.map